import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombreComercial: '',
    razonSocial: '',
    condicionFiscalId: 0,
    condicionFiscal: null,
    condicionFiscalNombre: null,
    documentoTipoId: 0,
    documentoTipo: null,
    documentoTipoNombre: null,
    documentoNumero: '',
    // cuit: '',
    direccion: '',
    paisId: 0,
    pais: null,
    paisNombre: null,
    provinciaId: 0,
    provincia: null,
    provinciaNombre: null,
    localidadId: 0,
    localidad: null,
    localidadNombre: null,
    telefono: '',
    celular: '',
    whatsapp: '',
    email: '',
    email2: '',
    bancoId: 0,
    banco: null,
    bancoNombre: null,
    bancoCuentaNumero: '',
    cbu: '',
    cbuAlias: '',
    transporte: false,
    impuestos: false,
    impuestoOrganismoId: 0,
    impuestoOrganismo: null,
    impuestoOrganismoNombre: null,
    impuestoPresentacionAnual: false,
    cuentaId: 0,
    cuenta: null,
    cuentaNombre: null,
    rubroId: 0,
    rubro: null,
    rubroNombre: null,
    subrubroId: 0,
    subrubro: null,
    subrubroNombre: null,
    formaPagoId: 0,
    formaPago: null,
    formaPagoNombre: null,
    formaPagoPlazo: 0,
    formaPagoObservaciones: '',
    tieneContrato: false,
    contratoPagare: false,
    noRequiereContrato: false,
    excluidoIndicadorPlazos: false,
    eventual: false,
    noEvaluar: false,
    inactivo: false,
    rowVersion: null,
    
    empresa: {
        paisId: 0
    },
    // condicionFiscalVisible: true,

    /* Para validar el CBU (si es Arg) */
    bancoPaisId: 0,

    proveedorId: 0,
    proveedorDatos: [],
    proveedorBancosCuentasDatos: [],
    proveedorEtiquetasDatos: [],
    proveedorEvaluacionesDatos: [],
    proveedorEvaluaciones: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_PROVEEDOR'(state, params) {
        state.id = 0;
        state.impuestos = false;
        state.impuestoOrganismoId = 0;
        state.impuestoOrganismo = null;
        state.impuestoOrganismoNombre = null;
        state.impuestoPresentacionAnual = false;

        if (params) {
            if (params.proveedorId) {
                state.id = params.proveedorId;
            }
            if (params.impuestoOrganismoId) {
                if (params.impuestoOrganismoId != 0) {
                    state.impuestos = true;
                    state.impuestoOrganismoId = params.impuestoOrganismoId;
                    state.impuestoOrganismo = null;
                    state.impuestoOrganismoNombre = null;
                }
            }

            state.empresa.paisId = params.paisId;
        }

        state.nombreComercial = '';
        state.razonSocial = '';
        state.condicionFiscalId = 0;
        state.condicionFiscal = null;
        state.condicionFiscalNombre = null;
        state.documentoTipoId = 0;
        state.documentoTipo = null;
        state.documentoTipoNombre = null;
        state.documentoNumero = '';
        // state.cuit = '';
        state.direccion = '';
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
        state.telefono = '';
        state.celular = '';
        state.whatsapp = '';
        state.email = '';
        state.email2 = '';
        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.bancoCuentaNumero = '';
        state.cbu = '';
        state.cbuAlias = '';
        state.transporte = false;
        // state.impuestos = false;
        // state.impuestoOrganismoId = 0;
        // state.impuestoOrganismo = null;
        // state.impuestoOrganismoNombre = null;
        state.cuentaId = 0;
        state.cuenta = null;
        state.cuentaNombre = null;
        state.rubroId = 0;
        state.rubro = null;
        state.rubroNombre = null;
        state.subrubroId = 0;
        state.subrubro = null;
        state.subrubroNombre = null;
        state.formaPagoId = 0;
        state.formaPago = null;
        state.formaPagoNombre = null;
        state.formaPagoPlazo = 0;
        state.formaPagoObservaciones = '';
        state.tieneContrato = false;
        state.contratoPagare = false;
        state.noRequiereContrato = false;
        state.excluidoIndicadorPlazos = false;
        state.eventual = false;
        state.noEvaluar = false;
        state.inactivo = false;
        state.rowVersion = null;

        state.bancoPaisId = 0;
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.nombreComercial = proveedor.nombreComercial.toUpperCase().trim();
        state.razonSocial = proveedor.razonSocial.toUpperCase().trim();
        state.condicionFiscalId = proveedor.condicionFiscal? proveedor.condicionFiscal.id : 0;
        state.condicionFiscal = proveedor.condicionFiscal;
        state.condicionFiscalNombre = proveedor.condicionFiscal? proveedor.condicionFiscal.nombre.trim() : null;
        state.documentoTipoId = proveedor.documentoTipo? proveedor.documentoTipo.id : 0;
        state.documentoTipo = proveedor.documentoTipo;
        state.documentoTipoNombre = proveedor.documentoTipo? proveedor.documentoTipo.nombre.trim() : null;
        state.documentoNumero = proveedor.documentoNumero.trim();
        // state.cuit = proveedor.cuit;
        state.direccion = proveedor.direccion.toUpperCase().trim();
        state.paisId = proveedor.pais? proveedor.pais.id : 0;
        state.pais = proveedor.pais;
        state.paisNombre = proveedor.pais? proveedor.pais.nombre.trim() : null;
        state.provinciaId = proveedor.provincia? proveedor.provincia.id : 0;
        state.provincia = proveedor.provincia;
        state.provinciaNombre = (proveedor.provincia) ? proveedor.provincia.nombre.trim() : null;
        state.localidadId = (proveedor.localidad) ? proveedor.localidad.id : 0;
        state.localidad = proveedor.localidad;
        state.localidadNombre = (proveedor.localidad) ? proveedor.localidad.nombre.trim() : null;
        state.telefono = proveedor.telefono;
        state.celular = proveedor.celular;
        state.whatsapp = proveedor.whatsapp;
        state.email = proveedor.email;
        state.email2 = proveedor.email2;
        state.transporte = proveedor.transporte;
        state.impuestos = proveedor.impuestos;
        state.impuestoOrganismoId = proveedor.impuestoOrganismo? proveedor.impuestoOrganismo.id : 0;
        state.impuestoOrganismo = proveedor.impuestoOrganismo;
        state.impuestoOrganismoNombre = proveedor.impuestoOrganismo? proveedor.impuestoOrganismo.nombre.trim() : null;
        state.impuestoPresentacionAnual = proveedor.impuestoPresentacionAnual;
        state.bancoId = proveedor.banco? proveedor.banco.id : 0;
        state.banco = proveedor.banco;
        state.bancoNombre = proveedor.banco? proveedor.banco.nombre.trim() : null;
        state.bancoCuentaNumero = proveedor.bancoCuentaNumero;
        state.cbu = proveedor.cbu;
        state.cbuAlias = proveedor.cbuAlias;
        state.cuentaId = (proveedor.cuenta) ? proveedor.cuenta.id : 0;
        state.cuenta = proveedor.cuenta;
        state.cuentaNombre = (proveedor.cuenta) ? proveedor.cuenta.nombre.trim() : null;
        state.rubroId = (proveedor.rubro) ? proveedor.rubro.id : 0;
        state.rubro = proveedor.rubro;
        state.rubroNombre = (proveedor.rubro) ? proveedor.rubro.nombre.trim() : null;
        state.subrubroId = (proveedor.subrubro) ? proveedor.subrubro.id : 0;
        state.subrubro = proveedor.subrubro;
        state.subrubroNombre = (proveedor.subrubro) ? proveedor.subrubro.nombre.trim() : null;
        state.formaPagoId = proveedor.formaPago? proveedor.formaPago.id : 0;
        state.formaPago = proveedor.formaPago;
        state.formaPagoNombre = proveedor.formaPago? proveedor.formaPago.nombre.trim() : null;
        state.formaPagoPlazo = proveedor.formaPagoPlazo;
        state.formaPagoObservaciones = proveedor.formaPagoObservaciones.trim();
        state.tieneContrato = proveedor.tieneContrato;
        state.contratoPagare = proveedor.contratoPagare;
        state.noRequiereContrato = proveedor.noRequiereContrato;
        state.excluidoIndicadorPlazos = proveedor.excluidoIndicadorPlazos;
        state.eventual = proveedor.eventual;
        state.noEvaluar = proveedor.noEvaluar;
        state.inactivo = proveedor.inactivo;
        state.rowVersion = proveedor.rowVersion;

        state.bancoPaisId = proveedor.banco? proveedor.banco.paisId : 0;
    },
    'SET_IMPUESTO_ORGANISMO'(state, impuestoOrganismo) {
        state.impuestoOrganismo = impuestoOrganismo;
        state.impuestoOrganismoId = impuestoOrganismo? impuestoOrganismo.id : 0;
        state.impuestoOrganismoNombre = impuestoOrganismo? impuestoOrganismo.nombre.trim() : null;
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;
        state.paisId = (pais) ? pais.id : 0;
        state.paisNombre = (pais) ? pais.nombre.trim() : null;
    },
    'SET_PROVINCIA'(state, provincia) {
        state.provincia = provincia;
        state.provinciaId = (provincia) ? provincia.id : 0;
        state.provinciaNombre = (provincia) ? provincia.nombre.trim() : null;
    },
    'SET_LOCALIDAD'(state, localidad) {
        state.localidad = localidad;
        state.localidadId = (localidad) ? localidad.id : 0;
        state.localidadNombre = (localidad) ? localidad.nombre.trim() : null;
    },
    'SET_CONDICIONFISCAL'(state, condicionFiscal) {
        state.condicionFiscal = condicionFiscal;
        state.condicionFiscalId = (condicionFiscal) ? condicionFiscal.id : 0;
        state.condicionFiscalNombre = (condicionFiscal) ? condicionFiscal.nombre.trim() : null;
    },
    'SET_DOCUMENTOTIPO'(state, documentoTipo) {
        state.documentoTipoId= documentoTipo? documentoTipo.id : 0;
        state.documentoTipo= documentoTipo;
        state.documentoTipoNombre = documentoTipo? documentoTipo.nombre.trim() : null;
    },
    'SET_BANCO'(state, banco) {
        state.banco = banco;

        if (banco) {
            state.bancoId = banco.id? banco.id : 0;
            state.bancoNombre = banco.nombre? banco.nombre.trim() : null;
            state.bancoPaisId = banco.paisId? banco.paisId : 0;
        } else {
            state.bancoId = 0;
            state.bancoNombre = null;
            state.bancoPaisId = 0;
        }
    },
    'SET_CUENTA'(state, cuenta) {
        state.cuenta = cuenta;
        state.cuentaId = (cuenta) ? cuenta.id : 0;
        state.cuentaNombre = (cuenta) ? cuenta.nombre.trim() : null;
    },
    'SET_RUBRO'(state, rubro) {
        state.rubro = rubro;
        state.rubroId = (rubro) ? rubro.id : 0;
        state.rubroNombre = (rubro) ? rubro.nombre.trim() : null;
    },
    'SET_SUBRUBRO'(state, subrubro) {
        state.subrubro = subrubro;
        state.subrubroId = (subrubro) ? subrubro.id : 0;
        state.subrubroNombre = (subrubro) ? subrubro.nombre.trim() : null;
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.formaPago = formaPago;
        state.formaPagoId = formaPago? formaPago.id : 0;
        state.formaPagoNombre = formaPago? formaPago.nombre.trim() : null;
    },
    'SET_PROVEEDOR_ID' (state, proveedor) {
        state.id = proveedor.id;
        state.rowVersion = proveedor.rowVersion;
    },

    'INICIALIZAR_PROVEEDOR_DATOS' (state, proveedorId) {
        state.proveedorId = proveedorId;
        state.proveedorDatos = [];
        state.proveedorBancosCuentasDatos = [];
        state.proveedorEvaluacionesDatos = [];
        state.proveedorEvaluaciones = [];
        state.proveedorEtiquetasDatos = [];
    },
    'SET_PROVEEDOR_DATOS' (state, params) {
        state.proveedorDatos = params.proveedorDatos;
        state.proveedorBancosCuentasDatos = params.proveedorBancosCuentasDatos;
        state.proveedorEvaluacionesDatos = params.proveedorEvaluacionesDatos;
        // state.proveedorEvaluaciones = params.proveedorEvaluaciones;
        state.proveedorEtiquetasDatos = params.proveedorEtiquetasDatos;
    },
    'SET_PROVEEDOR_EVALUACIONES_DATOS' (state, proveedorEvaluacionesDatos) {
        state.proveedorEvaluacionesDatos = proveedorEvaluacionesDatos;
    },
    'SET_PROVEEDOR_EVALUACIONES' (state, evaluaciones) {
        state.proveedorEvaluaciones = evaluaciones;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
    'ADD_ETIQUETA' (state, etiqueta) {
        state.proveedorEtiquetasDatos.push(etiqueta);
    },
    'REMOVE_ETIQUETA' (state, params) {
        let itemKey = state.proveedorEtiquetasDatos
            .findIndex(etiqueta => etiqueta.id == params.proveedorEtiquetaId);

        if (itemKey != -1) {
            state.proveedorEtiquetasDatos.splice(itemKey, 1);
        }
    },
};

const getters = {
    getField,

    proveedor(state) {
        return {
            id: state.id,
            nombreComercial: state.nombreComercial.toUpperCase().trim(),
            razonSocial: state.razonSocial.toUpperCase().trim(), 
            condicionFiscalId: state.condicionFiscalId,
            condicionFiscal: state.condicionFiscal,
            documentoTipoId: state.documentoTipoId,
            documentoTipo: state.documentoTipo,
            documentoNumero: state.documentoNumero,
            // cuit: state.cuit,
            telefono: state.telefono.toUpperCase().trim(),
            celular: state.celular.toUpperCase().trim(),
            whatsapp: state.whatsapp.toUpperCase().trim(),
            email: state.email.toLowerCase().trim(),
            email2: state.email2.toLowerCase().trim(),
            tieneContrato: false,
            contratoPagare: false,
            noRequiereContrato: false,
        }
    }
};

const actions = {
    inicializar ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }
            params.paisId = paisId;

            commit('INICIALIZAR_PROVEEDOR', params);
            
            let proveedorId = false;
            let impuestoOrganismoId = 0;

            if (params) {
                if (params.proveedorId) {
                    if (params.proveedorId != 0) {
                        proveedorId = params.proveedorId;
                    }
                }
                if (params.impuestoOrganismoId) {
                    if (params.impuestoOrganismoId != 0) {
                        impuestoOrganismoId = params.impuestoOrganismoId;
                    }
                }
            }

            if (proveedorId != 0) {
                apiAxios.get('proveedores/' + proveedorId + '/abm' ) 
                    .then(res => {
                        commit('SET_PROVEEDOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else if (impuestoOrganismoId != 0) {
                apiAxios.get('impuestosorganismos/' + impuestoOrganismoId ) 
                    .then(res => {
                        commit('SET_IMPUESTO_ORGANISMO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            let proveedor = {};
            let url = 'proveedores';

            if (state.impuestoOrganismoId != 0) {
                proveedor= {
                    nombreComercial: state.nombreComercial.toUpperCase().trim(),
                    impuestos: (/true/i).test(state.impuestos),
                    impuestoOrganismoId: state.impuestoOrganismoId,
                    impuestoPresentacionAnual: state.impuestoPresentacionAnual,
                    cuentaId: state.cuentaId, 
                    rubroId: state.rubroId, 
                    subrubroId: state.subrubroId, 
                    inactivo: state.inactivo,
                }
                url += '/impuestos';
            } else {
                proveedor= {
                    nombreComercial: state.nombreComercial.toUpperCase().trim(),
                    razonSocial: state.razonSocial.toUpperCase().trim(), 
                    condicionFiscalId: state.condicionFiscalId,
                    documentoTipoId: state.documentoTipoId,
                    documentoNumero: state.documentoNumero.toUpperCase().trim(),  
                    direccion: state.direccion.toUpperCase().trim(),
                    paisId: state.paisId,
                    provinciaId: state.provinciaId, 
                    localidadId: state.localidadId, 
                    telefono: state.telefono.toUpperCase().trim(),
                    celular: state.celular.toUpperCase().trim(),
                    whatsapp: state.whatsapp.toUpperCase().trim(),
                    email: state.email.toLowerCase().trim(),
                    email2: state.email2.toLowerCase().trim(),
                    bancoId: state.bancoId, 
                    bancoCuentaNumero: state.bancoCuentaNumero.toUpperCase().trim(),
                    cbu: state.cbu,
                    cbuAlias: state.cbuAlias.toUpperCase().trim(), 
                    transporte: (/true/i).test(state.transporte),
                    impuestos: (/true/i).test(state.impuestos),
                    impuestoOrganismoId: state.impuestoOrganismoId,
                    cuentaId: state.cuentaId, 
                    rubroId: state.rubroId, 
                    subrubroId: state.subrubroId, 
                    formaPagoId: state.formaPagoId,
                    formaPagoPlazo: state.formaPagoPlazo,
                    formaPagoObservaciones: state.formaPagoObservaciones.trim(),
                    tieneContrato: (/true/i).test(state.noRequiereContrato) ? false : (/true/i).test(state.tieneContrato),
                    contratoPagare: (/true/i).test(state.noRequiereContrato) ? false : ((/true/i).test(state.tieneContrato)? (/true/i).test(state.contratoPagare) : false),
                    noRequiereContrato: (/true/i).test(state.noRequiereContrato),
                    excluidoIndicadorPlazos: (/true/i).test(state.excluidoIndicadorPlazos),
                    eventual: (/true/i).test(state.eventual),
                    noEvaluar: (/true/i).test(state.noEvaluar),
                    inactivo: (/true/i).test(state.inactivo),
                }
            }

            if (state.id != 0) {
                url += '/' + state.id;
                proveedor.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, proveedor)
                .then(res => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_PROVEEDOR_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPais: ({commit}, pais) => {
        commit('SET_PAIS', pais);
    },
    setProvincia: ({commit}, provincia) => {
        commit('SET_PROVINCIA', provincia);
    },
    setLocalidad: ({commit}, localidad) => {
        commit('SET_LOCALIDAD', localidad);
    },
    setCondicionFiscal: ({commit}, condicionFiscal) => {
        commit('SET_CONDICIONFISCAL', condicionFiscal);
    },
    setDocumentoTipo: ({commit}, documentoTipo) => {
        commit('SET_DOCUMENTOTIPO', documentoTipo);
    },
    setBanco: ({commit}, banco) => {
        commit('SET_BANCO', banco);
    },
    setCuenta: ({commit}, cuenta) => {
        commit('SET_CUENTA', cuenta);
    },
    setRubro: ({commit}, rubro) => {
        commit('SET_RUBRO', rubro);
    },
    setSubrubro: ({commit}, subrubro) => {
        commit('SET_SUBRUBRO', subrubro);
    },
    setFormaPago: ({commit}, formaPago) => {
        commit('SET_FORMA_PAGO', formaPago);
    },

    getProveedorDatos ( { commit, rootState }, proveedorId ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }

            commit('INICIALIZAR_PROVEEDOR_DATOS', proveedorId);

            if (proveedorId != 0) {
                apiAxios.get('proveedores/' + proveedorId ) 
                .then(res => {
                    let proveedorDatos = [];
                    let proveedorBancosCuentasDatos = [];
                    let proveedorEtiquetasDatos = [];
                    let proveedorEvaluacionesDatos = [];

                    if ((/true/i).test(res.data.impuestos)) {
                        proveedorDatos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'impuestoOrganismo', 'campo': 'Organismo', 'valor': res.data.impuestoOrganismo, 'formato': '' },
                            { 'nombre': 'nombreComercial', 'campo': 'Nombre', 'valor': res.data.nombreComercial, 'formato': '' },
                            { 'nombre': 'cuenta', 'campo': 'Cuenta', 'valor': res.data.cuenta, 'formato': '' },
                            { 'nombre': 'impuestoPresentacionAnual', 'campo': 'Presentación', 'valor': res.data.impuestoPresentacionAnual? 'Anual' : 'Mensual', 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                    } else {
                        let formatoDocumentoNumero = '';
                        switch (res.data.documentoTipoId) {
                            case 2:
                                formatoDocumentoNumero = 'cuit';
                                break;
                            case 4:
                                formatoDocumentoNumero = 'ein';
                                break;
                        }

                        proveedorDatos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombreComercial', 'campo': 'Nombre Comercial', 'valor': res.data.nombreComercial, 'formato': '' },
                            { 'nombre': 'razonSocial', 'campo': 'Razón Social', 'valor': res.data.razonSocial, 'formato': '' },
                        ]

                        if (paisId == 1) {
                            proveedorDatos.push(
                                { 'nombre': 'condicionFiscal', 'campo': 'Condición Fiscal', 'valor': res.data.condicionFiscal, 'formato': '' },
                            )
                        }
                        
                        proveedorDatos.push(
                            { 'nombre': 'documentoTipo', 'campo': 'Tipo Identificación', 'valor': res.data.documentoTipo, 'formato': 'cuit' },
                            { 'nombre': 'documentoNumero', 'campo': 'Cód. Identificación', 'valor': res.data.documentoNumero, 'formato': formatoDocumentoNumero },
                            // { 'nombre': 'cuit', 'campo': 'CUIT', 'valor': res.data.cuit, 'formato': 'cuit' },
                            { 'nombre': 'direccion', 'campo': 'Dirección', 'valor': res.data.direccion, 'formato': '' },
                            { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                            { 'nombre': 'provincia', 'campo': 'Provincia', 'valor': res.data.provincia, 'formato': '' },
                            { 'nombre': 'localidad', 'campo': 'Localidad', 'valor': res.data.localidad, 'formato': '' },
                            { 'nombre': 'telefono', 'campo': 'Teléfono', 'valor': res.data.telefono, 'formato': '' },
                            { 'nombre': 'celular', 'campo': 'Celular', 'valor': res.data.celular, 'formato': '' },
                            { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                            { 'nombre': 'email2', 'campo': 'Email', 'valor': res.data.email2, 'formato': '' },
                            { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                            { 'nombre': 'bancoCuentaNumero', 'campo': 'Nro.Cuenta', 'valor': res.data.bancoCuentaNumero, 'formato': '' },
                            { 'nombre': 'cbu', 'campo': 'CBU', 'valor': res.data.cbu, 'formato': '' },
                            { 'nombre': 'cbuAlias', 'campo': 'CBU Alias', 'valor': res.data.cbuAlias, 'formato': '' },
                            { 'nombre': 'transporte', 'campo': 'Transporte', 'valor': (res.data.transporte) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'cuenta', 'campo': 'Cuenta', 'valor': res.data.cuenta, 'formato': '' },
                            { 'nombre': 'formaPago', 'campo': 'Forma de Pago', 'valor': res.data.formaPago, 'formato': '' },
                            { 'nombre': 'formaPagoPlazo', 'campo': 'Plazo', 'valor': res.data.formaPagoPlazo, 'formato': '' },
                            { 'nombre': 'formaPagoObservaciones', 'campo': 'Observaciones (Forma de Pago)', 'valor': res.data.formaPagoObservaciones, 'formato': '' },
                            { 'nombre': 'tieneContrato', 'campo': 'Tiene Contrato', 'valor': (res.data.tieneContrato) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'contratoPagare', 'campo': 'Contrato c/Pagare', 'valor': (res.data.contratoPagare) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'noRequiereContrato', 'campo': 'No Requiere Contrato', 'valor': (res.data.noRequiereContrato) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'excluidoIndicadorPlazos', 'campo': 'Excluido Indicador de Plazos de Pago', 'valor': (res.data.excluidoIndicadorPlazos) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'eventual', 'campo': 'Excluido del Ranking de Proveedores', 'valor': (res.data.eventual) ? 'Si' : 'No', 'formato': '' },
                            // { 'nombre': 'eventual', 'campo': 'Es Proveedor Eventual', 'valor': (res.data.eventual) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'noEvaluar', 'campo': 'No Evaluar', 'valor': (res.data.noEvaluar) ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        )
                        
                        proveedorBancosCuentasDatos = res.data.bancosCuentas;
                        proveedorEtiquetasDatos = res.data.etiquetas;
                        
                        proveedorEvaluacionesDatos = [
                            { 'nombre': 'promedioEvaluaciones', 'campo': 'Promedio Evaluaciones', 'valor': res.data.promedioEvaluaciones, 'formato': 'numero(2, true)' },
                            { 'nombre': 'cantidadEvaluaciones', 'campo': 'Cant. Evaluaciones', 'valor': res.data.cantidadEvaluaciones, 'formato': '' },
                            { 'nombre': 'fechaUltimaEvaluacion', 'campo': 'Últ. Evaluación', 'valor': res.data.fechaUltimaEvaluacion, 'formato': 'fecha' },
                        ]
                    }
                    
                    let params =  {
                        proveedorDatos,
                        proveedorBancosCuentasDatos,
                        proveedorEtiquetasDatos,
                        proveedorEvaluacionesDatos,
                        // proveedorEvaluaciones: res.data.evaluaciones
                    }
                    commit('SET_PROVEEDOR_DATOS', params);
                    
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)))
            }
            resolve();
        }, error => {
            reject(error);
        })
    },
    getProveedorEvaluacionesDatos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('proveedores/' + state.proveedorId ) 
            .then(res => {
                let proveedorEvaluacionesDatos = [
                    { 'nombre': 'promedioEvaluaciones', 'campo': 'Promedio Evaluaciones', 'valor': res.data.promedioEvaluaciones, 'formato': 'numero(2, true)' },
                    { 'nombre': 'cantidadEvaluaciones', 'campo': 'Cant. Evaluaciones', 'valor': res.data.cantidadEvaluaciones, 'formato': '' },
                    { 'nombre': 'fechaUltimaEvaluacion', 'campo': 'Últ. Evaluación', 'valor': res.data.fechaUltimaEvaluacion, 'formato': 'fecha' },
                ]
                
                commit('SET_PROVEEDOR_EVALUACIONES_DATOS', proveedorEvaluacionesDatos);
                
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)))
        }, error => {
            reject(error);
        })
    },
    getEvaluaciones ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            apiAxios.get('evaluacionesproveedores/proveedor/' + state.proveedorId + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PROVEEDOR_EVALUACIONES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    addEtiqueta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let etiqueta= {
                nombre: params.nombre.toUpperCase().trim(),
            }

            apiAxios.post('proveedores/' + params.proveedorId + '/etiquetas', etiqueta)
                .then(res => {
                    etiqueta.id = res.data.id;
                    
                    commit('ADD_ETIQUETA', etiqueta);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteEtiqueta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('proveedores/' + params.proveedorId + '/etiqueta/' + params.proveedorEtiquetaId + '/delete')
                .then(res => {
                    commit('REMOVE_ETIQUETA', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}